var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.977,
    height: 15.397,
    viewBox: "0 0 13.977 15.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 13.977,
    height: 15.397,
    fill: "#00246a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M13.375,2.838H10.429V2.023A2.024,2.024,0,0,0,8.408,0H5.57A2.025,2.025,0,0,0,3.548,2.023v.815H.6a.6.6,0,0,0,0,1.207h.816v9.33A2.024,2.024,0,0,0,3.441,15.4h7.1a2.024,2.024,0,0,0,2.021-2.022V4.045h.817a.6.6,0,0,0,0-1.207M4.753,2.023a.817.817,0,0,1,.817-.816H8.408a.817.817,0,0,1,.816.816v.815H4.753Zm6.6,11.352a.817.817,0,0,1-.816.816h-7.1a.818.818,0,0,1-.817-.816V4.045h8.728Z",
    transform: "translate(0 0)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M7.6,9a.6.6,0,0,0-.6.6v4.258a.6.6,0,0,0,1.206,0V9.6A.6.6,0,0,0,7.6,9",
    transform: "translate(-2.033 -2.614)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M11.6,9a.6.6,0,0,0-.6.6v4.258a.6.6,0,0,0,1.206,0V9.6a.6.6,0,0,0-.6-.6",
    transform: "translate(-3.195 -2.614)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinblue);
export default __webpack_public_path__ + "static/media/Binblue.43e6361cc83f1987bf2112a6bc89ac23.svg";
export { ForwardRef as ReactComponent };